import gql from 'graphql-tag';

/** Spec 3b Rev. 3 §4: a one-hour ed. pass that opens the drafts of one project in reader v3. */
export default gql`
  mutation LeserVorschauPass($projectId: Int!) {
    leserVorschauPass(project_id: $projectId) { pass }
  }
`;
